// src/components/SessionCard.tsx
import React from 'react';
import { FollowUp } from '../../../interfaces/FollowUp';
import { formatDateString } from '../../../functions/utils/formatDateString';
import { CiCalendarDate } from "react-icons/ci";
import { CgNotes } from "react-icons/cg";

interface FollowUpCardProps {
    followUp: FollowUp;
}

const FollowUpCard: React.FC<FollowUpCardProps> = ({
    followUp,
}) => {
    return (
        <div
            className="
        relative bg-white rounded-lg
        p-4 transition-transform transform flex flex-col
      "
        >
            <div className="flex-grow">
                <h2 className="text-lg font-semibold text-gray-800 mb-1">
                    {followUp.sessionRole?.label || followUp.sessionTitle}
                </h2>
                <div className='border rounded-md p-4'>
                    <div className='flex flex-row'>
                        <CgNotes className='mr-2' />
                        <small>{followUp.notes}</small>
                    </div>
                </div>
                <div className='flex flex-row gap-1 mt-2'>
                    <CiCalendarDate className="text-2xl" />
                    <small className="text-gray-600 mt-1">
                        {formatDateString(followUp.date.toDate().toISOString())}
                    </small>
                </div>
            </div>
        </div>
    );
};

export default FollowUpCard;
